import React from "react";
import ReactTable from "react-table-v6";
import "react-table-v6/react-table.css";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import {
    Icon,
    Modal,
    Grid,
    Form,
    Button,
    Card,
    Image,
    GridColumn,
    Input,
    Label,
    Dropdown,
    Message,
    Divider,
    Checkbox,
    Segment
} from "semantic-ui-react";
import excel from "../../Images/excel_icon.png";
import deleteIcon from "../../Images/delete-forever.png";
import editIcon from "../../Images/edit.png";
import datepickerIcon from "../../Images/datepic.png";
import {
    adminFileUpload, saveUploadedfile, fetchTemplates,fetchTemplatesById,
    deleteFileTemplate, fetchBranchMappingData, updateBranchMappingData,
    updateFileUploadValidity, updateFileName, updateOneTimeUpload,
    cloneMonthlyTemplateAction, importFileTemplatesAction
} from "../../actions/users_action.js";
import ButtonHandler from "../ButtonHandler.jsx";
import config from "../../config.js";
import SemanticDatepicker from 'react-semantic-ui-datepickers';
import 'react-semantic-ui-datepickers/dist/react-semantic-ui-datepickers.css';
import moment from "moment";

const conditionOptions = [
    { key: 'lt', text: '<', value: '<' },
    { key: 'gt', text: '>', value: '>' },
    { key: 'eq', text: '=', value: '=' }
];
class Templates extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            modalOpen: false,
            currentFile: {},
            fileName: '',
            fileTemplates: [],
            templateModalOpen: false,
            remarks: '',
            fileUploaded: false,
            fileColumns: [],
            fileCol: false,
            checkField: false,
            showDeleteConfirmModal: false,
            templates: [],
            fileHeaders: [],
            selectedTemplate: '',
            templateId: '',
            specialChar: '',
            showLeap: false,
            showSubD: false,
            master: [],
            modalBranchOpen: false,
            siteName: '',
            location: '',
            finalBranch: '',
            psr: '',
            clusterMaster: '',
            channel1Target: '',
            soorma: '',
            dgpTarget: '',
            datepickerModalOpen: false,
            enableStart: '',
            enableEnd: '',
            selectedFileName: '',
            selectedCondition: '>',
            editingFileTemplateId: null,
            editedFileNameDraft: '',
            cloneModalOpen: false,
            cloneStartDate: null,
            cloneEndDate: null,
            cloneLoading: false,
            cloneMessage: null,
            cloneMessageType: '',
            lastClonedAt: null,
            lastClonedBy: null,
            importSourceTemplateId: null,
            importSourceFileTemplates: [],
            importSelectedFileNames: [],
            importStartDate: null,
            importEndDate: null,
            importLoading: false,
            importMessage: null,
            importMessageType: '',
            importFetchingSource: false,
            importValidationError: null
        };
    }

    handleImportSourceChange = (e, data) => {
        const sourceTemplateId = data.value;
        if (!sourceTemplateId) {
            this.setState({
                importSourceTemplateId: null,
                importSourceFileTemplates: [],
                importSelectedFileNames: [],
                importMessage: null,
                importValidationError: null
            });
            return;
        }

        this.setState({
            importSourceTemplateId: sourceTemplateId,
            importFetchingSource: true,
            importSourceFileTemplates: [],
            importSelectedFileNames: [],
            importMessage: null,
            importValidationError: null
        });

        this.props.fetchTemplatesById(sourceTemplateId, {
            onSuccess: (res) => {
                const foundTemplate = (res.templates || []).find((t) => t._id === sourceTemplateId || t.id === sourceTemplateId);
                const sourceFiles = (foundTemplate && foundTemplate.fileTemplates) || [];
                this.setState({
                    importFetchingSource: false,
                    importSourceFileTemplates: sourceFiles
                });
            },
            onFailure: () => {
                this.setState({
                    importFetchingSource: false,
                    importMessage: "Failed to fetch source template details.",
                    importMessageType: "error"
                });
            }
        });
    };

    handleImportFileToggle = (fileName) => {
        const { importSelectedFileNames } = this.state;
        if (importSelectedFileNames.includes(fileName)) {
            this.setState({
                importSelectedFileNames: importSelectedFileNames.filter((name) => name !== fileName),
                importValidationError: null
            });
        } else {
            this.setState({
                importSelectedFileNames: [...importSelectedFileNames, fileName],
                importValidationError: null
            });
        }
    };

    handleImportSelectAll = (availableFileNames) => {
        this.setState({
            importSelectedFileNames: availableFileNames,
            importValidationError: null
        });
    };

    handleImportDeselectAll = () => {
        this.setState({
            importSelectedFileNames: [],
            importValidationError: null
        });
    };

    handleImportStartDateChange = (event, data) => {
        const val = data && data.value ? moment(data.value).format('YYYY-MM-DD') : null;
        this.setState({ importStartDate: val, importValidationError: null });
    };

    handleImportEndDateChange = (event, data) => {
        const val = data && data.value ? moment(data.value).format('YYYY-MM-DD') : null;
        this.setState({ importEndDate: val, importValidationError: null });
    };

    handleExecuteImport = () => {
        const {
            templateId,
            selectedTemplate,
            importSourceTemplateId,
            importSelectedFileNames,
            importStartDate,
            importEndDate
        } = this.state;

        if (!importSourceTemplateId) {
            this.setState({ importValidationError: "Please select a source template." });
            return;
        }

        if (!importSelectedFileNames || importSelectedFileNames.length === 0) {
            this.setState({ importValidationError: "Please select at least one file template to import." });
            return;
        }

        if (!importStartDate || !importEndDate) {
            this.setState({ importValidationError: "Start Date and End Date are mandatory for imported files." });
            return;
        }

        if (moment(importStartDate).isAfter(moment(importEndDate))) {
            this.setState({ importValidationError: "Start Date cannot be after End Date." });
            return;
        }

        this.setState({ importLoading: true, importMessage: null, importValidationError: null });

        const payload = {
            targetTemplateId: templateId,
            sourceTemplateId: importSourceTemplateId,
            selectedFileNames: importSelectedFileNames,
            fileEnableStart: importStartDate,
            fileEnableEnd: importEndDate
        };

        this.props.importFileTemplatesAction(payload, {
            onSuccess: (res) => {
                const message = res.message || "File templates imported successfully.";
                const messageType = res.status === "FAILED_VALIDATION" ? "error" : "success";
                this.setState({
                    importLoading: false,
                    importMessage: message,
                    importMessageType: messageType,
                    importSelectedFileNames: []
                });

                if (templateId) {
                    this.props.fetchTemplatesById(templateId, {
                        onSuccess: (freshRes) => {
                            const updated = (freshRes.templates || []).find((t) => t.name === selectedTemplate || t._id === templateId);
                            if (updated && updated.fileTemplates) {
                                this.setState({ fileTemplates: updated.fileTemplates });
                            }
                        },
                        onFailure: () => {}
                    });
                }
            },
            onFailure: (err) => {
                const errMsg = (err && err.response && err.response.data && err.response.data.message) || "Failed to import file templates.";
                this.setState({
                    importLoading: false,
                    importMessage: errMsg,
                    importMessageType: "error"
                });
            }
        });
    };

    openCloneModal = () => {
        this.setState({
            cloneModalOpen: true,
            cloneStartDate: null,
            cloneEndDate: null,
            cloneMessage: null,
            modalValidationError: null
        });
    }

    closeCloneModal = () => {
        this.setState({
            cloneModalOpen: false,
            cloneStartDate: null,
            cloneEndDate: null,
            modalValidationError: null
        });
    }

    handleCloneStartDateChange = (event, data) => {
        const val = data && data.value ? moment(data.value).format('YYYY-MM-DD') : null;
        this.setState({ cloneStartDate: val, modalValidationError: null });
    }

    handleCloneEndDateChange = (event, data) => {
        const val = data && data.value ? moment(data.value).format('YYYY-MM-DD') : null;
        this.setState({ cloneEndDate: val, modalValidationError: null });
    }

    handleExecuteTemplateClone = () => {
        if (!this.state.cloneStartDate || !this.state.cloneEndDate) {
            this.setState({ modalValidationError: "Start Date and End Date are mandatory." });
            return;
        }
        if (moment(this.state.cloneStartDate).isAfter(moment(this.state.cloneEndDate))) {
            this.setState({ modalValidationError: "Start Date cannot be after End Date." });
            return;
        }

        this.setState({ cloneLoading: true, cloneMessage: null, modalValidationError: null });
        const payload = {
            fileEnableStart: this.state.cloneStartDate,
            fileEnableEnd: this.state.cloneEndDate
        };

        this.props.cloneMonthlyTemplateAction(payload, {
            onSuccess: (res) => {
                const message = res.message || "Monthly template clone completed successfully.";
                const messageType = res.status === "FAILED_VALIDATION" ? "error" : "success";
                this.setState({
                    cloneLoading: false,
                    cloneModalOpen: false,
                    cloneMessage: message,
                    cloneMessageType: messageType,
                    lastClonedAt: res.clonedAt || null,
                    lastClonedBy: res.clonedBy || null
                });
                this.props.fetchTemplates({
                    onSuccess: (templatesRes) => {
                        if (templatesRes.templates && templatesRes.templates.length > 0) {
                            const latest = templatesRes.templates[templatesRes.templates.length - 1];
                            this.setState({
                                templates: templatesRes.templates,
                                selectedTemplate: latest.name,
                                templateId: latest._id,
                                fileTemplates: latest.fileTemplates
                            });
                        }
                    },
                    onFailure: () => {}
                });
            },
            onFailure: (err) => {
                const errMsg = (err && err.response && err.response.data && err.response.data.message) || "Failed to clone monthly template.";
                this.setState({
                    cloneLoading: false,
                    cloneModalOpen: false,
                    cloneMessage: errMsg,
                    cloneMessageType: "error"
                });
            }
        });
    }




    componentDidMount() {
        this.props.fetchTemplates({
            onSuccess: (res) => {
                this.setState({ templates: res.templates, selectedTemplate: res.templates[res.templates.length - 1]['name'], templateId: res.templates[res.templates.length - 1]['_id'], fileTemplates: res.templates[res.templates.length - 1]['fileTemplates'] })
            },
            onFailure: () => {

            }
        })
        this.props.fetchBranchMappingData({
            onSuccess: (res) => {
                this.setState({ master: res.result })
            },
            onFailure: () => {

            }

        })
    }

    fileupload = (file) => {
        this.setState({ currentFile: file.target.files[0], fileUploaded: true })
    };

    uploadFile = (fileName) => {
        this.setState({ fileName: fileName, modalOpen: true })
    }

    closeuploadoption = () => {
        this.setState({ modalOpen: false, datepickerModalOpen: false })
    }

    closeTemplateModal = () => {
        this.setState({ templateModalOpen: false })
    }

    uploadTemplate = () => {
        this.props.adminFileUpload(this.state.currentFile, this.state.fileName,
            {
                onSuccess: (res) => {
                    let fileData = {
                        fileName: this.state.fileName,
                        fileUrl: res.fileUrl,
                        remarks: this.state.remarks,
                        templateId: this.state.templateId
                    }
                    this.setState({ fileColumns: res.columns, fileUrl: res.fileUrl, fileHeaders: res.headers })
                    this.props.saveUploadedfile(fileData, {
                        onSuccess: () => {
                            alert('Success')
                            this.setState({ modalOpen: false, templateModalOpen: false, fileCol: true })
                            this.props.fetchTemplatesById(this.state.templateId,{
                                onSuccess: (res) => {
                                    res.templates.map((d) => {
                                        if (d.name == this.state.selectedTemplate) {
                                            this.setState({ fileTemplates: d.fileTemplates })
                                        }
                                    })

                                },
                                onFailure: () => {

                                }
                            })
                        },
                        onFailure: () => {

                        }
                    })
                },
                onFailure: () => {

                }
            }
        )
    }

    downloadFile = (url) => {
        window.open(url);
    }

    addNewTemplate = () => {
        this.setState({ templateModalOpen: true, fileName: '' })
    }

    fileNameOnChange = (e) => {
        this.setState({ fileName: e.target.value })
    }

    remarksOnChange = (e) => {
        this.setState({ remarks: e.target.value })
    }

    closeFileColModal = () => {
        this.setState({ fileCol: false })
    }

    saveFileColTemplate = () => {
        let fileData = {
            fileName: this.state.fileName,
            fileUrl: this.state.fileUrl,
            remarks: this.state.remarks,
            fieldsConditions: this.state.fileColumns,
            headers: this.state.fileHeaders,
            templateId: this.state.templateId,
            specialChar: this.state.specialChar
        }
        this.props.saveUploadedfile(fileData, {
            onSuccess: () => {
                alert('Template Fields Conditions Added')
                this.setState({ modalOpen: false, templateModalOpen: false, fileCol: false })
                this.props.fetchTemplatesById(this.state.templateId,{
                    onSuccess: (res) => {
                        res.templates.map((d) => {
                            if (d.name == this.state.selectedTemplate) {
                                this.setState({ fileTemplates: d.fileTemplates })
                            }
                        })
                    },
                    onFailure: () => {

                    }
                })
            },
            onFailure: () => {

            }
        })
    }

    // checkFieldsFilled = () => {

    //     const fields = this.state.fileColumns

    //     if (fields.length == 2) {
    //         let check1 = fields[0].every(checkfield)
    //         let check2 = fields[1].every(checkfield)

    //         function checkfield(field) {
    //             return Object.keys(field).length >= 3;
    //         }
    //         if (check1 == true && check2 == true) {
    //             this.setState({ checkField: true })
    //         }
    //         else {
    //             this.setState({ checkField: false })
    //         }


    //     }
    //     else {
    //         let check = fields.every(checkfield)

    //         function checkfield(field) {
    //             return Object.keys(field).length >= 3;
    //         }

    //         this.setState({ checkField: check })
    //     }

    // }

    checkFieldsFilled = () => { 
    const fields = this.state.fileColumns;

    const checkfield = (field) => {
    // charType and optional are mandatory for all fields
    if (!field.charType || !field.optional) {
        return false;
    }
    
    // If charType is Numeric, validate conditions
    // if (field.charType === 'Numeric') {
    //     // Check if conditionSymbol exists and is not empty
    //     const hasValidSymbol = field.conditionSymbol && field.conditionSymbol.trim() !== '';
        
    //     // Check if conditions exists and is a valid number
    //     const hasValidCondition = field.conditions !== undefined && 
    //                              field.conditions !== '' &&
    //                              /^[+-]?\d+(\.\d+)?$/.test(String(field.conditions));
        
    //     return hasValidCondition && hasValidSymbol;
    // }
    
    // For non-Numeric types, having charType and optional is enough
    return true;
    };


    if (fields.length === 2) {
        let check1 = fields[0].every(checkfield);
        let check2 = fields[1].every(checkfield);
        this.setState({ checkField: check1 && check2 });
    } else {
        let check = fields.every(checkfield);
        this.setState({ checkField: check });
    }
};

    // dropDownColOnChange = (e, data) => {
    //     let updatedCol = this.state.fileColumns
    //     console.log(data, 'data')
    //     console.log(updatedCol, 'updateColl')
    //     if (updatedCol.length == 2) {
    //         if (data.additionLabel.split('-')[1] == 'LEAP') {
    //             updatedCol[0].map((d) => {

    //                 if (d.headerName == data.additionLabel.split('-')[0]) {
    //                     if (data.placeholder == 'Mandatory') {
    //                         if (data.value == 'Primary') {
    //                             d.optional = data.value
    //                         }
    //                         else {
    //                             d.optional = data.value
    //                         }
    //                     }
    //                     else {
    //                         d.charType = data.value
    //                     }
    //                 }
    //             })
    //             this.setState({ fileColumns: updatedCol })
    //         }
    //         else {
    //             updatedCol[1].map((d) => {

    //                 if (d.headerName == data.additionLabel.split('-')[0]) {
    //                     if (data.placeholder == 'Mandatory') {
    //                         if (data.value == 'Primary') {
    //                             d.optional = data.value
    //                         }
    //                         else {
    //                             d.optional = data.value
    //                         }
    //                     }
    //                     else {
    //                         d.charType = data.value
    //                     }
    //                 }
    //             })
    //             this.setState({ fileColumns: updatedCol })

    //         }
    //         this.checkFieldsFilled();
    //     }
    //     else {
    //         updatedCol.map((d) => {
    //             if (d.headerName == data.additionLabel) {
    //                 if (data.placeholder == 'Mandatory') {
    //                     if (data.value == 'Primary') {
    //                         d.optional = data.value
    //                     }
    //                     else {
    //                         d.optional = data.value
    //                     }
    //                 }
    //                 else {
    //                     d.charType = data.value
    //                 }
    //             }
    //         })
    //         this.setState({ fileColumns: updatedCol })
    //         this.checkFieldsFilled();
    //     }
    //     console.log(updatedCol, 'updateColl')


    // }


    // handleConditionChange = (e, d) => {
    //     let value = e;
    //     if ( /^[+-]?\d+$/.test(value)) {
    //         this.fileColOnChange(e, d, 'conditions', value);
    //         this.setState({checkField:true})
    //     }
    //     else if(value === ''){
    //         this.fileColOnChange(e, d, 'conditions', value);
    //         this.setState({checkField:false})
    //     }
    // };

    dropDownColOnChange = (e, data, field, fieldType, sheetType) => {
    const value = data.value;
    const propertyToUpdate = fieldType === 'mandatory' ? 'optional' : 'charType';

    const updateField = (f) => {
        if (f.headerName === field.headerName) {
            return { ...f, [propertyToUpdate]: value };
        }
        return f;
    };

    let updatedCol;
    if (this.state.fileColumns.length === 2) {
        updatedCol = [...this.state.fileColumns];
        if (sheetType === 'LEAP') {
            updatedCol[0] = updatedCol[0].map(updateField);
        } else if (sheetType === 'SUBD') {
            updatedCol[1] = updatedCol[1].map(updateField);
        }
    } else {
        updatedCol = this.state.fileColumns.map(updateField);
    }

    this.setState({ fileColumns: updatedCol }, () => {
        this.checkFieldsFilled();
    });
}
    
    handleConditionChange = (e, d) => {
    let value = e;
    if (/^[+-]?\d+$/.test(value)) {
        this.fileColOnChange(e, d, 'conditions', value);
        // Call checkFieldsFilled instead of directly setting state
        setTimeout(() => this.checkFieldsFilled(), 0);
    } else if (value === '') {
        this.fileColOnChange(e, d, 'conditions', value);
        setTimeout(() => this.checkFieldsFilled(), 0);
    }
};

    // handleConditionSymbolsChange = (e,d,value) => {
    //     this.fileColOnChange(value, d, 'conditionSymbol','');
    //     this.setState({checkField:false})
    // };

    handleConditionSymbolsChange = (e, d, value) => {
    this.fileColOnChange(value, d, 'conditionSymbol', '');
    // Call checkFieldsFilled instead of directly setting false
    setTimeout(() => this.checkFieldsFilled(), 0);
};

    fileColOnChange = (e, d, res, type) => {
        let updatedCol = this.state.fileColumns
        if (updatedCol.length == 2) {
            if (type == 'leap') {
                updatedCol[0].map((f) => {
                    if (f.headerName == d.headerName) {
                        f[res] = e
                    }
                })
                this.setState({ fileColumns: updatedCol })
            }
            else {
                updatedCol[1].map((f) => {
                    if (f.headerName == d.headerName) {
                        f[res] = e
                    }
                })
                this.setState({ fileColumns: updatedCol })
            }
            this.checkFieldsFilled();
        }
        else {
            updatedCol.map((f) => {
                if (f.headerName == d.headerName) {
                    f[res] = e
                }
            })
            this.setState({ fileColumns: updatedCol })
            this.checkFieldsFilled();
        }

    }

    delIconClick = (d) => {
        this.setState({ showDeleteConfirmModal: true, fileName: d.fileName })
    }

    closeCandidateDeleteModal = () => {
        this.setState({ showDeleteConfirmModal: false })
    }

    deleteTemplateFile = () => {
        let fileData = {
            fileName: this.state.fileName,
            templateName: this.state.selectedTemplate,
            templateId: this.state.templateId
        }
        this.props.deleteFileTemplate(fileData, {
            onSuccess: () => {
                this.setState({ showDeleteConfirmModal: false })
                this.props.fetchTemplatesById(this.state.templateId,{
                    onSuccess: (res) => {
                        res.templates.map((d) => {
                            if (d.name == this.state.selectedTemplate) {
                                this.setState({ fileTemplates: d.fileTemplates })
                            }
                        })
                    },
                    onFailure: () => {

                    }
                })
            },
            onFailure: () => {

            }
        })
    }

    editIconClick = (d) => {
        if (d.fieldsConditions) {
            this.setState({ fileCol: true, fileColumns: d.fieldsConditions, fileHeaders: d.requiredCol, fileName: d.fileName, fileUrl: d.fileUrl, remarks: d.remarks, specialChar: d.specialChar }, () => {
                this.checkFieldsFilled();
            })
        }
        else {
            alert('Conditions Not Applied for this Template')
        }
    }

    dateIconClick = (d) => {
        console.log(d, 'dddd')
        if (d.fileEnableStart && d.fileEnableEnd) {
            this.setState({ enableStart: d.fileEnableStart, enableEnd: d.fileEnableEnd })
        }
        else {
            this.setState({ enableStart: '', enableEnd: '' })
        }
        this.setState({ datepickerModalOpen: true, selectedFileName: d.fileName })
    }

    dropDownTemplateOnChange = (e, data) => {
        let templateId = ''
        data.options.map((d) => {
            if (data.value == d.value) {
                templateId = d.key
            }
        })
        this.props.fetchTemplatesById(templateId, {
            onSuccess: (res) => {
                res.templates.map((d) => {
                    if (d.name == data.value) {
                        console.log('inside')
                        this.setState({  selectedTemplate: data.value, templateId: templateId, fileTemplates: d.fileTemplates })
                    }
                })
            },
            onFailure: () => {

            }
        })
    }

    specialCharOnChange = (e) => {
        this.setState({ specialChar: e.target.value })
    }

    startFileNameEdit = (d) => {
        this.setState({
            editingFileTemplateId: d.id,
            editedFileNameDraft: d.editedFileName || d.fileName
        })
    }

    handleFileNameDraftChange = (e) => {
        this.setState({ editedFileNameDraft: e.target.value })
    }

    cancelFileNameEdit = () => {
        this.setState({ editingFileTemplateId: null, editedFileNameDraft: '' })
    }

    saveEditedFileName = (d) => {
        const editedName = (this.state.editedFileNameDraft || '').trim()
        const currentName = (d.editedFileName || d.fileName || '').trim()

        if (editedName === '') {
            this.cancelFileNameEdit()
            return
        }

        if (editedName === currentName) {
            this.cancelFileNameEdit()
            return
        }

        const data = {
            templateId: this.state.templateId,
            fileTemplateId: d.id,
            editedFileName: editedName
        }

        this.props.updateFileName(data, {
            onSuccess: () => {
                this.setState({ editingFileTemplateId: null, editedFileNameDraft: '' })
                this.props.fetchTemplatesById(this.state.templateId, {
                    onSuccess: (res) => {
                        res.templates.map((temp) => {
                            if (temp.name == this.state.selectedTemplate) {
                                this.setState({ fileTemplates: temp.fileTemplates })
                            }
                        })
                    },
                    onFailure: () => {}
                })
            },
            onFailure: () => {
                alert('Unable to update file name')
                this.cancelFileNameEdit()
            }
        })
    }

    handleFileNameInputKeyDown = (e, d) => {
        if (e.key === 'Enter') {
            this.saveEditedFileName(d)
        }
        if (e.key === 'Escape') {
            this.cancelFileNameEdit()
        }
    }

    showLeapData = () => {
        this.setState({ showLeap: !this.state.showLeap })
    }

    showSubData = () => {
        this.setState({ showSubD: !this.state.showSubD })
    }

    closeModal = () => {
        this.setState({ modalBranchOpen: false })
    }
    siteNameChange = (e) => {
        this.setState({ siteName: e.target.value })
    }
    locationChange = (e) => {
        this.setState({ location: e.target.value })
    }
    finalBranchChange = (e) => {
        this.setState({ finalBranch: e.target.value })
    }
    psrChange = (e) => {
        this.setState({ psr: e.target.value })
    }
    clusterMasterChange = (e) => {
        this.setState({ clusterMaster: e.target.value })
    }
    channel1TargetChange = (e) => {
        this.setState({ channel1Target: e.target.value })
    }
    soormaOnChange = (e) => {
        this.setState({ soorma: e.target.value })
    }
    dgpTargetChange = (e) => {
        this.setState({ dgpTarget: e.target.value })
    }

    addNewBranch = () => {
        this.setState({ modalBranchOpen: true })
    }

    saveNewBranch = () => {
        let data = {
            "Site Name": this.state.siteName,
            "Location": this.state.location,
            "Final Branch": this.state.finalBranch,
            "PSR": this.state.psr,
            "Cluster Master": this.state.clusterMaster,
            "channel 1 target": this.state.channel1Target,
            "Soorma": this.state.soorma,
            "DGP Target": this.state.dgpTarget
        }
        this.props.updateBranchMappingData(data,
            {
                onSuccess: () => {
                    this.setState({ modalBranchOpen: false })
                    this.props.fetchBranchMappingData({
                        onSuccess: (res) => {
                            this.setState({ master: res.result })
                        },
                        onFailure: () => {

                        }

                    })
                },
                onFailure: () => {

                }
            }
        )
    }

    handleStartDateChange = (e, data) => {
        const val = data && data.value ? moment(data.value).format('YYYY-MM-DD') : '';
        this.setState({ enableStart: val })
    }

    handleEndDateChange = (e, data) => {
        const val = data && data.value ? moment(data.value).format('YYYY-MM-DD') : '';
        this.setState({ enableEnd: val })
    }

    updateDates = () => {

        let data = {
            startDate: this.state.enableStart,
            endDate: this.state.enableEnd,
            templateMonth: this.state.selectedTemplate,
            fileName: this.state.selectedFileName
        }
        console.log(data, 'datatatata')

        this.props.updateFileUploadValidity(data,
            {
                onSuccess: () => {
                    alert('File Upload Time Period Updated Successfully')
                    this.setState({ datepickerModalOpen: false })
                    this.props.fetchTemplatesById(this.state.templateId,{
                        onSuccess: (res) => {
                            res.templates.map((d) => {
                                if (d.name == this.state.selectedTemplate) {
                                    this.setState({ fileTemplates: d.fileTemplates })
                                }
                            })
                        },
                        onFailure: () => {

                        }
                    })
                },
                onFailure: () => {

                }
            }
        )

        console.log(data, 'data')
    }

    isOneTimeToggleEligible = (fileTemplate) => {
        const supportedFileNames = ['Seller Master', 'Store Master'];
        return supportedFileNames.includes((fileTemplate && fileTemplate.fileName) || '');
    }

    onOneTimeUploadToggle = (fileTemplate) => {
        const currentState = Boolean(fileTemplate.one_time_upload);
        const nextState = !currentState;
        const actionText = nextState ? 'enable' : 'disable';

        const confirmed = window.confirm(
            `Are you sure you want to ${actionText} one-time successful upload restriction for ${fileTemplate.fileName}?`
        );

        if (!confirmed) {
            return;
        }

        const payload = {
            templateMonth: this.state.selectedTemplate,
            fileName: fileTemplate.fileName,
            oneTimeUpload: nextState
        };

        this.props.updateOneTimeUpload(payload, {
            onSuccess: () => {
                this.props.fetchTemplatesById(this.state.templateId, {
                    onSuccess: (res) => {
                        res.templates.map((d) => {
                            if (d.name == this.state.selectedTemplate) {
                                this.setState({ fileTemplates: d.fileTemplates })
                            }
                        })
                    },
                    onFailure: () => {}
                })
            },
            onFailure: () => {
                alert('Unable to update one-time upload setting.')
            }
        })
    }


    render() {
        console.log(this.state.selectedTemplate, 'selected Template')
        var templateMonths = []

        this.state.templates.map((d) => {
            templateMonths.push({
                'key': d._id,
                'value': d.name,
                'text': d.name
            })
        })

        var columns = [
            {
                Header: "Site Name",
                accessor: "Site Name",
            },
            {
                Header: "Location",
                accessor: "Location",
            },
            {
                Header: "Final Branch",
                accessor: "Final Branch",
            },
            {
                Header: "PSR",
                accessor: "PSR",
            },
            {
                Header: "Cluster Master",
                accessor: "Cluster Master",
            },
            {
                Header: "Channel 1 target",
                accessor: "channel 1 target",
            },
            {
                Header: "Soorma",
                accessor: "Soorma",
            },
            {
                Header: "DGP Target",
                accessor: "DGP Target",
            },

        ]

        var charType = [
            {
                'key': 'Numeric',
                'value': 'Numeric',
                'text': 'Numeric'
            },
            {
                'key': 'Alpha Numeric',
                'value': 'Alpha Numeric',
                'text': 'Alpha Numeric'
            },
            {
                'key': 'Alphabet',
                'value': 'Alphabet',
                'text': 'Alphabet'
            },
            {
                'key': 'Special Char',
                'value': 'Special Char',
                'text': 'Special Char'
            }
        ]

        var conditions = [
            {
                'key': 'Primary',
                'value': 'Primary',
                'text': 'Primary'
            },
            {
                'key': 'Secondary',
                'value': 'Secondary',
                'text': 'Secondary'
            }
        ]

        const role = (this.props.auth && this.props.auth.role) || (this.props.user && this.props.user.role) || '';
        const isUserAdmin = role.toLowerCase() === 'admin';

        const latestTemplate = this.state.templates && this.state.templates.length > 0
            ? this.state.templates[this.state.templates.length - 1]
            : null;
        const clonedAt = this.state.lastClonedAt || (latestTemplate && latestTemplate.cloned_at);
        const clonedBy = this.state.lastClonedBy || (latestTemplate && latestTemplate.cloned_by) || "Celery Beat";

        return (
            <div>
                {isUserAdmin && (
                    <Card fluid style={{ marginBottom: 25, border: '1px solid #2185d0' }}>
                        <Card.Content>
                            <Card.Header style={{ color: '#2185d0', fontSize: '1.2em' }}>
                                <Icon name="clone" /> Template Creation
                            </Card.Header>
                            <Card.Description style={{ marginTop: 10 }}>
                                <p style={{ color: '#666' }}>
                                    Clone the previous month template configuration and map distributor users for the current month.
                                </p>
                                <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: '15px' }}>
                                    <Button
                                        color="blue"
                                        onClick={this.openCloneModal}
                                        loading={this.state.cloneLoading}
                                        disabled={this.state.cloneLoading}
                                    >
                                        <Icon name="copy" /> Clone Monthly Template
                                    </Button>
                                    {clonedAt && (
                                        <span style={{ color: '#555', fontSize: '0.9em', backgroundColor: '#f4f7fa', padding: '7px 12px', borderRadius: '4px', border: '1px solid #d4d4d5' }}>
                                            <Icon name="clock outline" color="blue" />
                                            <strong>Last Cloned:</strong> {moment(clonedAt).format("DD MMM YYYY, HH:mm:ss")} via <strong>{clonedBy}</strong>
                                        </span>
                                    )}
                                </div>
                                {this.state.cloneMessage && (
                                    <Message
                                        style={{ marginTop: 15 }}
                                        positive={this.state.cloneMessageType === 'success'}
                                        negative={this.state.cloneMessageType === 'error'}
                                        onDismiss={() => this.setState({ cloneMessage: null })}
                                    >
                                        <Message.Header>
                                            {this.state.cloneMessageType === 'success' ? 'Success' : 'Notice'}
                                        </Message.Header>
                                        <p>{this.state.cloneMessage}</p>
                                    </Message>
                                )}

                                <Divider horizontal style={{ marginTop: 25, marginBottom: 20 }}>
                                    <Icon name="exchange" color="blue" /> Import Templates
                                </Divider>

                                <div style={{ marginTop: 15 }}>
                                    <p style={{ color: '#666' }}>
                                        Selectively import previous month template schemas into <strong>{this.state.selectedTemplate || 'the active template'}</strong>.
                                    </p>

                                    {this.state.importValidationError && (
                                        <Message negative size="small" style={{ marginBottom: 15 }}>
                                            <p>{this.state.importValidationError}</p>
                                        </Message>
                                    )}

                                    {this.state.importMessage && (
                                        <Message
                                            style={{ marginBottom: 15 }}
                                            positive={this.state.importMessageType === 'success'}
                                            negative={this.state.importMessageType === 'error'}
                                            onDismiss={() => this.setState({ importMessage: null })}
                                        >
                                            <Message.Header>
                                                {this.state.importMessageType === 'success' ? 'Success' : 'Notice'}
                                            </Message.Header>
                                            <p>{this.state.importMessage}</p>
                                        </Message>
                                    )}

                                    <Form>
                                        <Grid columns={2} stackable>
                                            <Grid.Row>
                                                <Grid.Column width={16} style={{ marginBottom: 15 }}>
                                                    <h4 style={{ marginBottom: 5, color: '#333' }}>
                                                        Source Template <span style={{ color: '#db2828' }}>*</span>:
                                                    </h4>
                                                    <Dropdown
                                                        placeholder="Select Source Template to Import From"
                                                        fluid
                                                        search
                                                        selection
                                                        options={(this.state.templates || [])
                                                            .filter((t) => t._id !== this.state.templateId && t.name !== this.state.selectedTemplate)
                                                            .map((t) => ({
                                                                key: t._id,
                                                                text: t.name,
                                                                value: t._id
                                                            }))}
                                                        value={this.state.importSourceTemplateId}
                                                        onChange={this.handleImportSourceChange}
                                                        loading={this.state.importFetchingSource}
                                                    />
                                                </Grid.Column>
                                            </Grid.Row>

                                            {this.state.importSourceTemplateId && (
                                                <Grid.Row>
                                                    <Grid.Column width={16}>
                                                        <Segment secondary style={{ padding: '15px' }}>
                                                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10 }}>
                                                                <h4 style={{ margin: 0, color: '#333' }}>
                                                                    <Icon name="file alternate outline" /> Select File Templates to Import
                                                                </h4>
                                                                {(() => {
                                                                    const currentTargetFileTemplates = this.state.fileTemplates || [];
                                                                    const existingNames = new Set(
                                                                        currentTargetFileTemplates
                                                                            .filter((ft) => ft && ft.fileName)
                                                                            .map((ft) => ft.fileName.trim().toLowerCase())
                                                                    );
                                                                    const existingTypes = new Set(
                                                                        currentTargetFileTemplates
                                                                            .filter((ft) => ft && ft.fileType)
                                                                            .map((ft) => ft.fileType.trim().toLowerCase())
                                                                    );

                                                                    const importableNames = (this.state.importSourceFileTemplates || [])
                                                                        .filter((srcFt) => {
                                                                            const nameNorm = (srcFt.fileName || '').trim().toLowerCase();
                                                                            const typeNorm = (srcFt.fileType || '').trim().toLowerCase();
                                                                            return nameNorm && !existingNames.has(nameNorm) && (!typeNorm || !existingTypes.has(typeNorm));
                                                                        })
                                                                        .map((srcFt) => srcFt.fileName);

                                                                    return (
                                                                        <div>
                                                                            <Button
                                                                                size="mini"
                                                                                basic
                                                                                color="blue"
                                                                                type="button"
                                                                                disabled={importableNames.length === 0}
                                                                                onClick={() => this.handleImportSelectAll(importableNames)}
                                                                            >
                                                                                Select All Importable ({importableNames.length})
                                                                            </Button>
                                                                            <Button
                                                                                size="mini"
                                                                                basic
                                                                                color="grey"
                                                                                type="button"
                                                                                disabled={this.state.importSelectedFileNames.length === 0}
                                                                                onClick={this.handleImportDeselectAll}
                                                                            >
                                                                                Deselect All
                                                                            </Button>
                                                                        </div>
                                                                    );
                                                                })()}
                                                            </div>

                                                            {this.state.importFetchingSource ? (
                                                                <p style={{ color: '#888' }}><Icon loading name="spinner" /> Loading files from source template...</p>
                                                            ) : (!this.state.importSourceFileTemplates || this.state.importSourceFileTemplates.length === 0) ? (
                                                                <p style={{ color: '#888', fontStyle: 'italic' }}>No file templates found in selected source template.</p>
                                                            ) : (
                                                                <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', maxHeight: '250px', overflowY: 'auto', paddingRight: '5px' }}>
                                                                    {this.state.importSourceFileTemplates.map((srcFt, idx) => {
                                                                        const currentTargetFileTemplates = this.state.fileTemplates || [];
                                                                        const srcName = (srcFt.fileName || '').trim();
                                                                        const srcType = (srcFt.fileType || '').trim();
                                                                        const srcNameNorm = srcName.toLowerCase();
                                                                        const srcTypeNorm = srcType.toLowerCase();

                                                                        const nameExists = currentTargetFileTemplates.some(
                                                                            (ft) => (ft.fileName || '').trim().toLowerCase() === srcNameNorm
                                                                        );
                                                                        const typeExists = srcType && currentTargetFileTemplates.some(
                                                                            (ft) => (ft.fileType || '').trim().toLowerCase() === srcTypeNorm
                                                                        );
                                                                        const isDuplicate = nameExists || typeExists;
                                                                        const isChecked = this.state.importSelectedFileNames.includes(srcName);

                                                                        return (
                                                                            <div
                                                                                key={srcFt.id || idx}
                                                                                style={{
                                                                                    display: 'flex',
                                                                                    alignItems: 'center',
                                                                                    justifyContent: 'space-between',
                                                                                    padding: '8px 12px',
                                                                                    backgroundColor: isDuplicate ? '#f9f9f9' : (isChecked ? '#edf7fe' : '#ffffff'),
                                                                                    borderRadius: '4px',
                                                                                    border: `1px solid ${isChecked ? '#2185d0' : '#e0e0e0'}`
                                                                                }}
                                                                            >
                                                                                <Checkbox
                                                                                    label={
                                                                                        <label style={{ color: isDuplicate ? '#999' : '#333', cursor: isDuplicate ? 'not-allowed' : 'pointer' }}>
                                                                                            <strong>{srcName}</strong>
                                                                                            {srcType && <span style={{ color: '#777', marginLeft: 8, fontSize: '0.9em' }}>({srcType})</span>}
                                                                                        </label>
                                                                                    }
                                                                                    checked={isChecked}
                                                                                    disabled={isDuplicate}
                                                                                    onChange={() => this.handleImportFileToggle(srcName)}
                                                                                />
                                                                                {isDuplicate && (
                                                                                    <Label color="grey" size="tiny">
                                                                                        <Icon name="ban" /> Already exists in current template
                                                                                    </Label>
                                                                                )}
                                                                            </div>
                                                                        );
                                                                    })}
                                                                </div>
                                                            )}

                                                            <Divider style={{ margin: '15px 0' }} />

                                                            <Grid columns={2} stackable>
                                                                <Grid.Row>
                                                                    <Grid.Column>
                                                                        <h5 style={{ marginBottom: 5, color: '#333' }}>
                                                                            Imported File Start Date <span style={{ color: '#db2828' }}>*</span>:
                                                                        </h5>
                                                                        <SemanticDatepicker
                                                                            pointing={'top left'}
                                                                            onChange={this.handleImportStartDateChange}
                                                                            value={this.state.importStartDate ? new Date(this.state.importStartDate) : null}
                                                                            clearable
                                                                        />
                                                                        {this.state.importStartDate && (
                                                                            <div style={{ marginTop: 5, fontSize: '0.85em', color: '#2185d0' }}>
                                                                                Selected: {this.state.importStartDate}
                                                                            </div>
                                                                        )}
                                                                    </Grid.Column>
                                                                    <Grid.Column>
                                                                        <h5 style={{ marginBottom: 5, color: '#333' }}>
                                                                            Imported File End Date <span style={{ color: '#db2828' }}>*</span>:
                                                                        </h5>
                                                                        <SemanticDatepicker
                                                                            pointing={'top left'}
                                                                            onChange={this.handleImportEndDateChange}
                                                                            value={this.state.importEndDate ? new Date(this.state.importEndDate) : null}
                                                                            clearable
                                                                        />
                                                                        {this.state.importEndDate && (
                                                                            <div style={{ marginTop: 5, fontSize: '0.85em', color: '#2185d0' }}>
                                                                                Selected: {this.state.importEndDate}
                                                                            </div>
                                                                        )}
                                                                    </Grid.Column>
                                                                </Grid.Row>
                                                            </Grid>

                                                            <div style={{ marginTop: 15, display: 'flex', justifyContent: 'flex-end' }}>
                                                                <Button
                                                                    color="teal"
                                                                    onClick={this.handleExecuteImport}
                                                                    loading={this.state.importLoading}
                                                                    disabled={
                                                                        this.state.importLoading ||
                                                                        this.state.importSelectedFileNames.length === 0 ||
                                                                        !this.state.importStartDate ||
                                                                        !this.state.importEndDate
                                                                    }
                                                                >
                                                                    <Icon name="cloud download" /> Import {this.state.importSelectedFileNames.length > 0 ? `(${this.state.importSelectedFileNames.length}) ` : ''}File Template(s)
                                                                </Button>
                                                            </div>
                                                        </Segment>
                                                    </Grid.Column>
                                                </Grid.Row>
                                            )}
                                        </Grid>
                                    </Form>
                                </div>
                            </Card.Description>
                        </Card.Content>
                    </Card>
                )}

                <Modal
                    open={this.state.cloneModalOpen}
                    onClose={this.closeCloneModal}
                    size="small"
                >
                    <Modal.Header>
                        <Icon name="copy" color="blue" /> Clone Monthly Template
                    </Modal.Header>
                    <Modal.Content>
                        <p style={{ color: '#555', marginBottom: 15 }}>
                            Clone the previous month's template and map distributor users for the current month.
                            Please specify the Start Date and End Date for the template files (both dates are mandatory).
                        </p>
                        {this.state.modalValidationError && (
                            <Message negative size="small" style={{ marginBottom: 15 }}>
                                <p>{this.state.modalValidationError}</p>
                            </Message>
                        )}
                        <Form>
                            <Grid columns={2}>
                                <Grid.Row>
                                    <Grid.Column style={{ marginTop: 10 }}>
                                        <h4 style={{ marginBottom: 5, color: '#333' }}>
                                            Start Date <span style={{ color: '#db2828' }}>*</span>:
                                        </h4>
                                        <SemanticDatepicker
                                            pointing={'top left'}
                                            onChange={this.handleCloneStartDateChange}
                                            value={this.state.cloneStartDate ? new Date(this.state.cloneStartDate) : null}
                                            clearable
                                        />
                                        {this.state.cloneStartDate && (
                                            <div style={{ marginTop: 5, fontSize: '0.85em', color: '#2185d0' }}>
                                                Selected: {this.state.cloneStartDate}
                                            </div>
                                        )}
                                    </Grid.Column>
                                    <Grid.Column style={{ marginTop: 10 }}>
                                        <h4 style={{ marginBottom: 5, color: '#333' }}>
                                            End Date <span style={{ color: '#db2828' }}>*</span>:
                                        </h4>
                                        <SemanticDatepicker
                                            pointing={'top left'}
                                            onChange={this.handleCloneEndDateChange}
                                            value={this.state.cloneEndDate ? new Date(this.state.cloneEndDate) : null}
                                            clearable
                                        />
                                        {this.state.cloneEndDate && (
                                            <div style={{ marginTop: 5, fontSize: '0.85em', color: '#2185d0' }}>
                                                Selected: {this.state.cloneEndDate}
                                            </div>
                                        )}
                                    </Grid.Column>
                                </Grid.Row>
                            </Grid>
                        </Form>
                    </Modal.Content>
                    <Modal.Actions>
                        <Button
                            color="red"
                            onClick={this.closeCloneModal}
                            disabled={this.state.cloneLoading}
                        >
                            <Icon name="remove" /> Cancel
                        </Button>
                        <Button
                            color="green"
                            onClick={this.handleExecuteTemplateClone}
                            loading={this.state.cloneLoading}
                            disabled={this.state.cloneLoading || !this.state.cloneStartDate || !this.state.cloneEndDate}
                        >
                            <Icon name="check" /> Confirm & Clone
                        </Button>
                    </Modal.Actions>
                </Modal>
                <h1
                    style={{

                        flex: "0 0 30px",
                        display: "inline-block",
                        color: "#2185d0",
                    }}
                >
                    Template Details
                </h1>
                <br />
                <div style={{ display: 'flex', flexDirection: 'row' }}>

                    <div>
                        <Dropdown placeholder='Select Month' search selection options={templateMonths}
                            onChange={this.dropDownTemplateOnChange}
                            value={this.state.selectedTemplate}

                        />
                    </div>
                    <div style={{ marginLeft: 30 }}>
                        <Label
                            style={{ justifyContent: 'flex-end', cursor: "pointer" }}
                            size="large"
                            color="blue"
                            onClick={this.addNewTemplate}
                        >
                            <Icon name="user plus" />
                            Add Template
                        </Label>
                    </div>
                </div>

                <Grid columns={4} style={{ marginTop: 20 }}>
                    {this.state.fileTemplates.map((d) => {
                        return (

                            <GridColumn>
                                <Card.Group>
                                    <Card fluid style={{ marginBottom: 20 }}>
                                        <Card.Content>
                                            <Image
                                                floated='right'
                                                size='mini'
                                                src={deleteIcon}
                                                onClick={(e) => {
                                                    if (this.props.auth.userName !== 'MatrixLogin') {
                                                        this.delIconClick(d);
                                                    }
                                                }}
                                                style={{ cursor: this.props.auth.userName === 'MatrixLogin' ? 'not-allowed' : 'pointer' }}

                                            />
                                            <Image
                                                floated='right'
                                                size='mini'
                                                src={editIcon}
                                                onClick={() => this.editIconClick(d)}
                                                style={{ cursor: 'pointer' }}
                                            />
                                            <Image
                                                floated='right'
                                                size='mini'
                                                src={datepickerIcon}
                                                onClick={() => this.dateIconClick(d)}
                                                style={{ cursor: 'pointer' }}
                                            />
                                            <Card.Header>
                                                <div style={{ display: 'flex', alignItems: 'center', gap: 4, minHeight: 28 }}>
                                                    {this.state.editingFileTemplateId === d.id ? (
                                                        <Input
                                                            autoFocus
                                                            value={this.state.editedFileNameDraft}
                                                            onChange={this.handleFileNameDraftChange}
                                                            onBlur={() => this.saveEditedFileName(d)}
                                                            onKeyDown={(e) => this.handleFileNameInputKeyDown(e, d)}
                                                            size='small'
                                                            style={{ width: 130, height: 32, backgroundColor: '#f2f2f2', borderRadius: 4, boxShadow: 'none' }}
                                                        />
                                                    ) : (
                                                        <span>{d.editedFileName || d.fileName}</span>
                                                    )}
                                                    {this.state.editingFileTemplateId !== d.id && (
                                                        <Icon
                                                            name='edit'
                                                            size='small'
                                                            style={{ cursor: 'pointer', margin: 0 }}
                                                            onClick={() => this.startFileNameEdit(d)}
                                                        />
                                                    )}
                                                </div>
                                            </Card.Header>
                                            <Card.Description>
                                                {d.remarks}
                                            </Card.Description>
                                            {this.isOneTimeToggleEligible(d) && (
                                                <div style={{ marginTop: 10 }}>
                                                    <Form.Checkbox
                                                        toggle
                                                        label='One-time successful upload lock'
                                                        checked={Boolean(d.one_time_upload)}
                                                        onChange={() => this.onOneTimeUploadToggle(d)}
                                                    />
                                                </div>
                                            )}
                                        </Card.Content>
                                        <Card.Content extra>
                                            <div style={{ display: 'flex', justifyContent: 'space-around' }}>
                                                <Button basic color='green' onClick={() => this.downloadFile(d.fileUrl)}>
                                                    <Icon name="download" />
                                                    Download

                                                </Button>
                                                <Button basic color='red' onClick={() => this.uploadFile(d.fileName)}>
                                                    <Icon name="upload" />
                                                    Upload
                                                </Button>
                                            </div>
                                        </Card.Content>
                                    </Card>
                                </Card.Group>
                            </GridColumn>


                        )
                    })}
                </Grid>
                <Modal
                    open={this.state.modalOpen}
                    onClose={this.closeuploadoption}
                    size="mini"
                >
                    <Modal.Content>
                        <Form>
                            <Grid columns={1}>
                                <Grid.Row>

                                    <Grid.Column style={{ marginTop: 20 }}>
                                        <h4>Upload Master data :</h4>
                                        <Input
                                            type="file"
                                            accept=".xlsx"
                                            onChange={this.fileupload}
                                            multiple
                                        />
                                    </Grid.Column>
                                </Grid.Row>
                            </Grid>
                        </Form>
                    </Modal.Content>

                    <Modal.Actions>
                        <div style={{ display: 'flex', flexDirection: "row", justifyContent: "flex-end" }}>
                            <ButtonHandler
                                click={this.uploadTemplate}
                                title={'Upload'}
                                color={'green'}
                                iconColor={'white'}
                            />
                            <ButtonHandler
                                click={this.closeuploadoption}
                                isIcon={true}
                                color={'red'}
                                iconName={'remove'}
                                iconColor={'white'}
                                title={'Close'}
                            />
                        </div>

                    </Modal.Actions>
                </Modal>
                <Modal
                    open={this.state.templateModalOpen}
                    onClose={this.closeTemplateModal}
                    size="mini"
                >
                    <Modal.Content>
                        <Form>
                            <Grid columns={1}>
                                <Grid.Row>
                                    <GridColumn>
                                        <Form.Input
                                            type="any"
                                            label="File Name"
                                            value={this.state.fileName}
                                            onChange={(e) => this.fileNameOnChange(e)}
                                            placeholder="fileName"
                                        />
                                    </GridColumn>
                                    <GridColumn style={{ marginTop: 20 }}>
                                        <Form.Input
                                            type="any"
                                            label="Remarks"
                                            value={this.state.remarks}
                                            onChange={(e) => this.remarksOnChange(e)}
                                            placeholder="remarks"
                                        />
                                    </GridColumn>

                                    <Grid.Column style={{ marginTop: 20 }}>
                                        <h4>Upload Master data :</h4>
                                        <Input
                                            type="file"
                                            accept=".xlsb"
                                            onChange={this.fileupload}
                                            multiple
                                        />
                                    </Grid.Column>
                                </Grid.Row>
                            </Grid>
                        </Form>
                    </Modal.Content>

                    <Modal.Actions>
                        <div style={{ display: 'flex', flexDirection: "row", justifyContent: "flex-end" }}>
                            <ButtonHandler
                                click={this.uploadTemplate}
                                title={'Upload'}
                                color={'green'}
                                iconColor={'white'}
                                disabled={this.state.fileName != '' && this.state.remarks != '' && this.state.fileUploaded == true ? false : true}

                            />
                            <ButtonHandler
                                click={this.closeTemplateModal}
                                isIcon={true}
                                color={'red'}
                                iconName={'remove'}
                                iconColor={'white'}
                                title={'Close'}
                            />
                        </div>

                    </Modal.Actions>
                </Modal>


                <Modal
                    open={this.state.fileCol}
                    onClose={this.closeFileColModal}
                    size="fullscreen"
                >
                    <Modal.Content>
                        <Form>
                            <Form.Input
                                type="any"
                                label="Special Characters (Ex: !@%////.&()-)"
                                value={this.state.specialChar}
                                onChange={(e) => this.specialCharOnChange(e)}
                                placeholder="please define Special Character Here"
                            />

                            {this.state.fileName == 'DGP Target' || this.state.fileName == 'SBD Report' || this.state.fileName == 'Adaptive Trade Terms' ?
                                this.state.fileColumns.map((sheet, inx) => {


                                    return (
                                        sheet.map((d, index) => {
                                            return (

                                                <Grid columns={5}>


                                                    {index == 0 && inx == 0 &&
                                                        <Grid.Row>
                                                            <Grid.Column style={{ marginTop: 20 }}>
                                                                {/* <strong>{'**** LEAP *****'}</strong> */}
                                                                <ButtonHandler
                                                                    click={this.showLeapData}
                                                                    title={'LEAP'}
                                                                    color={'green'}
                                                                    iconColor={'white'}
                                                                />
                                                            </Grid.Column>
                                                        </Grid.Row>
                                                    }
                                                    {index == 0 && inx == 1 &&
                                                        <Grid.Row>
                                                            <Grid.Column style={{ marginTop: 20 }}>
                                                                {/* <strong>{'**** SubD *****'}</strong> */}
                                                                <ButtonHandler
                                                                    click={this.showSubData}
                                                                    title={'SubD'}
                                                                    color={'green'}
                                                                    iconColor={'white'}
                                                                />
                                                            </Grid.Column>
                                                        </Grid.Row>
                                                    }
                                                    {this.state.showLeap == true && inx == 0 &&


                                                        <Grid.Row>
                                                            <Grid.Column style={{ marginTop: 20 }}>
                                                                {d.headerName}

                                                            </Grid.Column>
                                                            <GridColumn style={{ marginTop: 20 }}>
                                                                <Dropdown placeholder='Char Type' search selection options={charType}
                                                                    onChange={(e, data) => this.dropDownColOnChange(e, data, d, 'charType', 'LEAP')}
                                                                    value={d.charType}

                                                                />
                                                            </GridColumn>
                                                            <GridColumn style={{ marginTop: 20 }}>
                                                                <Dropdown placeholder='Mandatory' search selection options={conditions}
                                                                    onChange={(e, data) => this.dropDownColOnChange(e, data, d, 'mandatory', 'LEAP')}
                                                                    value={d.optional}

                                                                />
                                                            </GridColumn>
                                                            <GridColumn>
                                                                <Form.Input
                                                                    type="any"
                                                                    label="Restrictions"
                                                                    value={d.restrictions}
                                                                    onChange={(e) => this.fileColOnChange(e.target.value, d, 'restrictions', 'leap')}

                                                                />
                                                            </GridColumn>
                                                            {console.log(d.charType, 'charType')}
                                                            
                                                            <Grid.Column>
                                                                <Form.Field>
                                                                    <label>Conditions</label>
                                                                    <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                                                                        <Dropdown
                                                                            selection
                                                                            value={d.conditionSymbol}
                                                                            options={conditionOptions}
                                                                            onChange={(e, { value }) => this.handleConditionSymbolsChange(e, d, value)}
                                                                            disabled={d.charType !== "Numeric"}
                                                                            style={{ minWidth: 80 }}
                                                                        />
                                                                        {d.charType === "Numeric" && (
                                                                            <Form.Input
                                                                                type="text"
                                                                                value={d.conditions}
                                                                                onChange={(e) => this.handleConditionChange(e.target.value, d)}
                                                                                pattern="^-?\d+$"
                                                                                inputMode="numeric"
                                                                                style={{ width: 100 }} // Prevents collapse
                                                                            />
                                                                        )}
                                                                    </div>
                                                                </Form.Field>
                                                            </Grid.Column>
                                                        </Grid.Row>
                                                    }
                                                    {this.state.showSubD == true && inx == 1 &&


                                                        <Grid.Row>
                                                            <Grid.Column style={{ marginTop: 20 }}>
                                                                {d.headerName}

                                                            </Grid.Column>
                                                            <GridColumn style={{ marginTop: 20 }}>
                                                                <Dropdown placeholder='Char Type' search selection options={charType}
                                                                    onChange={(e, data) => this.dropDownColOnChange(e, data, d, 'charType', 'SUBD')}
                                                                    value={d.charType}

                                                                />
                                                            </GridColumn>
                                                            <GridColumn style={{ marginTop: 20 }}>
                                                                <Dropdown placeholder='Mandatory' search selection options={conditions}
                                                                    onChange={(e, data) => this.dropDownColOnChange(e, data, d, 'mandatory', 'SUBD')}
                                                                    value={d.optional}

                                                                />
                                                            </GridColumn>
                                                            <GridColumn>
                                                                <Form.Input
                                                                    type="any"
                                                                    label="Restrictions"
                                                                    value={d.restrictions}
                                                                    onChange={(e) => this.fileColOnChange(e.target.value, d, 'restrictions', 'subd')}

                                                                />
                                                            </GridColumn>
                                                            {console.log(d.charType, 'charType')}
                                                            
                                                            <Grid.Column>
                                                                <Form.Field>
                                                                    <label>Conditions</label>
                                                                    <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                                                                        <Dropdown
                                                                            selection
                                                                            value={d.conditionSymbol}
                                                                            options={conditionOptions}
                                                                            onChange={(e, { value }) => this.handleConditionSymbolsChange(e, d, value)}
                                                                            disabled={d.charType !== "Numeric"}
                                                                            style={{ minWidth: 80 }}
                                                                        />
                                                                        {d.charType === "Numeric" && (
                                                                            <Form.Input
                                                                                type="text"
                                                                                value={d.conditions}
                                                                                onChange={(e) => this.handleConditionChange(e.target.value, d)}
                                                                                pattern="^-?\d+$"
                                                                                inputMode="numeric"
                                                                                style={{ width: 100 }} // Prevents collapse
                                                                            />
                                                                        )}
                                                                    </div>
                                                                </Form.Field>
                                                            </Grid.Column>
                                                        </Grid.Row>
                                                    }
                                                </Grid>
                                            )
                                        })
                                    )



                                }) :
                                this.state.fileColumns.map((d) => {

                                    return (
                                       

                                        <Grid columns={5}>
                                            <Grid.Row>

                                                <Grid.Column style={{ marginTop: 20, minWidth: 100 }}>{d.headerName}</Grid.Column>

                                                <Grid.Column style={{ marginTop: 20, minWidth: 120 }}>
                                                    <Dropdown
                                                        placeholder="Char Type"
                                                        search
                                                        selection
                                                        options={charType}
                                                        onChange={(e, data) => this.dropDownColOnChange(e, data, d, 'charType')}
                                                        value={d.charType}
                                                    />
                                                </Grid.Column>

                                                <Grid.Column style={{ marginTop: 20, minWidth: 120 }}>
                                                    <Dropdown
                                                        placeholder="Mandatory"
                                                        search
                                                        selection
                                                        options={conditions}
                                                        onChange={(e, data) => this.dropDownColOnChange(e, data, d, 'mandatory')}
                                                        value={d.optional}
                                                    />
                                                </Grid.Column>

                                                <Grid.Column>
                                                    <Form.Input
                                                        type="text"
                                                        label="Restrictions"
                                                        value={d.restrictions}
                                                        onChange={(e) => this.fileColOnChange(e.target.value, d, "restrictions", "")}
                                                    />
                                                </Grid.Column>

                                                <Grid.Column>
                                                    <Form.Field>
                                                        <label>Conditions</label>
                                                        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                                                            <Dropdown
                                                                selection
                                                                value={d.conditionSymbol}
                                                                options={conditionOptions}
                                                                onChange={(e, { value }) => this.handleConditionSymbolsChange(e, d, value)}
                                                                disabled={d.charType !== "Numeric"}
                                                                style={{ minWidth: 80 }}
                                                            />
                                                            {d.charType === "Numeric" && (
                                                                <Form.Input
                                                                    type="text"
                                                                    value={d.conditions}
                                                                    onChange={(e) => this.handleConditionChange(e.target.value, d)}
                                                                    pattern="^-?\d+$"
                                                                    inputMode="numeric"
                                                                    style={{ width: 100 }} // Prevents collapse
                                                                />
                                                            )}
                                                        </div>
                                                    </Form.Field>
                                                </Grid.Column>

                                            </Grid.Row>
                                        </Grid>

                                    )

                                })}

                        </Form>
                    </Modal.Content>

                    <Modal.Actions>
                        <div style={{ display: 'flex', flexDirection: "row", justifyContent: "flex-end" }}>
                            <ButtonHandler
                                click={this.saveFileColTemplate}
                                title={'Save'}
                                color={'green'}
                                iconColor={'white'}
                                disabled={this.state.checkField == true ? false : true}
                            />
                            {/* <ButtonHandler
                                click={this.closeFileColModal}
                                isIcon={true}
                                color={'red'}
                                iconName={'remove'}
                                iconColor={'white'}
                                title={'Close'}
                                disabled={this.state.checkField == true ? false : true}
                            /> */}
                        </div>

                    </Modal.Actions>
                </Modal>
                <Modal size={'small'} open={this.state.showDeleteConfirmModal} onClose={this.closeCandidateDeleteModal}>
                    <Modal.Content>
                        <p>Are you sure you want to delete this file from Templates?</p>
                    </Modal.Content>
                    <Modal.Actions>
                        <Button negative onClick={this.closeCandidateDeleteModal}>No</Button>
                        <Button primary onClick={this.deleteTemplateFile}>Yes</Button>
                    </Modal.Actions>
                </Modal>

                <Modal
                    open={this.state.datepickerModalOpen}
                    onClose={this.closeuploadoption}
                    size="small"
                >
                    <Modal.Content>
                        <Form>
                            <Grid columns={2}>
                                <Grid.Row>
                                    <Grid.Column style={{ marginTop: 20 }}>
                                        <h3>Choose Start Date:</h3>
                                        <SemanticDatepicker
                                            filterDate={(date) => {
                                                const selectedMonth = new Date().getMonth();
                                                const selectedYear = new Date().getFullYear();
                                                const now = new Date();
                                                now.setDate(now.getDate() - 1);

                                                return date.getMonth() === selectedMonth && date.getFullYear() === selectedYear;
                                            }}
                                            pointing={'top left'}
                                            onChange={this.handleStartDateChange}
                                            value={this.state.enableStart != '' && this.state.enableStart != undefined ? new Date(this.state.enableStart) : this.state.enableStart}
                                        />
                                    </Grid.Column>

                                    <Grid.Column style={{ marginTop: 20 }}>
                                        <h3>Choose End Date:</h3>
                                        <SemanticDatepicker
                                            filterDate={(date) => {
                                                const now = new Date();
                                                now.setDate(now.getDate() - 1);
                                                const selectedMonth = date.getMonth();
                                                const selectedYear = date.getFullYear();
                                                return (
                                                    (selectedYear > now.getFullYear()) ||
                                                    (selectedYear === now.getFullYear() && selectedMonth >= now.getMonth())
                                                );
                                            }}
                                            pointing={'top left'}
                                            onChange={this.handleEndDateChange}
                                            value={this.state.enableEnd != '' && this.state.enableEnd != undefined ? new Date(this.state.enableEnd) : this.state.enableEnd}
                                        />
                                    </Grid.Column>
                                </Grid.Row>
                            </Grid>
                        </Form>
                    </Modal.Content>

                    <Modal.Actions>
                        <div style={{ display: 'flex', flexDirection: "row", justifyContent: "flex-end" }}>
                            <ButtonHandler
                                click={this.updateDates}
                                title={'Save'}
                                color={'green'}
                                iconColor={'white'}
                            />
                            <ButtonHandler
                                click={this.closeuploadoption}
                                isIcon={true}
                                color={'red'}
                                iconName={'remove'}
                                iconColor={'white'}
                                title={'Close'}
                            />
                        </div>

                    </Modal.Actions>
                </Modal>

                <h1
                    style={{

                        flex: "0 0 30px",
                        display: "inline-block",
                        color: "#2185d0",
                    }}
                >
                    Branch Mapping Details
                </h1>
                <div style={{ marginLeft: 30 }}>
                    <Label
                        style={{ justifyContent: 'flex-end', cursor: "pointer" }}
                        size="large"
                        color="blue"
                        onClick={this.addNewBranch}
                    >
                        <Icon name="plus" />
                        Add Branch
                    </Label>
                </div>

                {this.state.master.length > 0 &&

                    <div style={{ display: "flex", overflowX: "scroll", marginTop: 20 }}>
                        <ReactTable
                            noDataText="We couldn't find anything"
                            filterable={true}
                            defaultPageSize={20}
                            sortable={true}
                            style={{ width: "85vw", marginLeft: 30 }}
                            columns={columns}
                            data={this.state.master}
                        />
                    </div>

                }
                <Modal
                    open={this.state.modalBranchOpen}
                    onClose={this.closeModal}
                    size="small"
                >
                    <Modal.Content>
                        <Form>
                            <Grid columns={2}>
                                <Grid.Row>
                                    <Grid.Column style={{ marginTop: 20 }}>
                                        <Form.Input
                                            type="text"
                                            label="Site Name"
                                            value={this.state.siteName}
                                            onChange={(e) => this.siteNameChange(e)}
                                            placeholder="Site Name"
                                        />
                                    </Grid.Column>
                                    <Grid.Column style={{ marginTop: 20 }}>
                                        <Form.Input
                                            type="text"
                                            label="Location"
                                            value={this.state.location}
                                            onChange={(e) => this.locationChange(e)}
                                            placeholder="Location"
                                        />
                                    </Grid.Column>
                                    <Grid.Column style={{ marginTop: 20 }}>
                                        <Form.Input
                                            type="any"
                                            label="Final Branch"
                                            value={this.state.finalBranch}
                                            onChange={(e) => this.finalBranchChange(e)}
                                            placeholder="Final Branch"
                                        />
                                    </Grid.Column>
                                    <Grid.Column style={{ marginTop: 20 }}>
                                        <Form.Input
                                            type="any"
                                            label="PSR"
                                            value={this.state.psr}
                                            onChange={(e) => this.psrChange(e)}
                                            placeholder="PSR"
                                        />
                                    </Grid.Column>
                                    <Grid.Column style={{ marginTop: 20 }}>
                                        <Form.Input
                                            type="any"
                                            label="Cluster Master"
                                            value={this.state.clusterMaster}
                                            onChange={(e) => this.clusterMasterChange(e)}
                                            placeholder="Cluster Master"
                                        />
                                    </Grid.Column>

                                    <GridColumn style={{ marginTop: 20 }}>
                                        <Form.Input
                                            type="any"
                                            label="Channel 1 Target"
                                            value={this.state.channel1Target}
                                            onChange={(e) => this.channel1TargetChange(e)}
                                            placeholder="Channel 1 Target"
                                        />
                                    </GridColumn>
                                    <GridColumn style={{ marginTop: 20 }}>
                                        <Form.Input
                                            type="any"
                                            label="Soorma"
                                            value={this.state.soorma}
                                            onChange={(e) => this.soormaOnChange(e)}
                                            placeholder="Soorma"
                                        />
                                    </GridColumn>
                                    <GridColumn style={{ marginTop: 20 }}>
                                        <Form.Input
                                            type="any"
                                            label="DGP Target"
                                            value={this.state.dgpTarget}
                                            onChange={(e) => this.dgpTargetChange(e)}
                                            placeholder="DGP Target"
                                        />
                                    </GridColumn>

                                </Grid.Row>
                            </Grid>
                        </Form>
                    </Modal.Content>
                    <Modal.Actions style={{ marginTop: 20 }}>
                        <Button color="red" onClick={this.closeModal}>
                            <Icon name="remove" /> Cancel
                        </Button>

                        <Button
                            color="green"
                            disabled={this.state.siteName != '' && this.state.finalBranch != '' && this.state.channel1Target != '' && this.state.location != '' && this.state.psr != '' && this.state.dgpTarget != '' && this.state.clusterMaster != '' ? false : true}
                            onClick={this.saveNewBranch}
                        >
                            Save
                        </Button>
                    </Modal.Actions>
                </Modal>

            </div>

        )

    }
}

const mapStateToProps = (state) => {
    return {
        auth: state.auth,
        user: state.user,
    };
};

    const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(
        {
            adminFileUpload,
            saveUploadedfile,
            fetchTemplates,
            deleteFileTemplate,
            fetchBranchMappingData,
            updateBranchMappingData,
            updateFileUploadValidity,
            fetchTemplatesById,
            updateFileName,
            updateOneTimeUpload,
            cloneMonthlyTemplateAction,
            importFileTemplatesAction
        },
        dispatch
    );
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Templates));
